import './styles.css';

/**
 * Страница для владельцев пунктов выдачи
 * @returns {JSX.Element}
 */
export const ForOwners: React.FC = () => {
    return (
        <div className="owners-container">
        <h1 className="owners-title">Владельцам пуктов выдачи</h1>
        <div className="owners-content">
            <p>Приглашаем к  партнерству владельцев пунктов выдачи интернет-заказов в следующих городах:</p>
            <ul className="owners-list">
                <li>Иркутск</li>
                <li>Магадан</li>
                <li>Комсомольск-на-Амуре</li>
                <li>Чита</li>
                <li>Петропавловск-Камчатский</li>
                <li>Артем</li>
            </ul>
            {/* <p>Пишите нам на электронный адрес <a href="mailto:km.podzamenu@gmail.com" style="color: #ce5e02;">km.podzamenu@gmail.com</a> с темой “Сотрудничество ПВЗ” либо звоните/пишите на <a href="https://api.whatsapp.com/send?phone=79147169282" style="color: #ce5e02;" target="_blank">WhatsApp +79147169282</a></p> */}
        </div>
    </div>
    );
};